import { all, call, put, takeLatest, takeEvery } from 'redux-saga/effects';
import {
  fetchFieldPins,
  createFieldPin,
  deleteFieldPin,
  updateTableColumnDefinition,
  fetchGlobalPreSetData,
} from '../routines';
import { request } from '../../common/util/RestClient';
import envConfig from '../../config';
import SUCCESS_MESSAGES from '../../common/constants/SuccessMessagesConstants';

export function* fetchFieldPinsSaga({ payload }) {
  const format = payload.format || 'object';
  const { level, scope } = payload;
  if (!level) throw new TypeError('Level cannot be null or undefined');
  try {
    const URL = `${envConfig.APIG_URL}core/field-pins?format=${format}&level=${payload.level}`;
    const response = yield call(request, URL);
    yield put(fetchFieldPins.success({ response, scope }));
  } catch (error) {
    yield put(fetchFieldPins.failure({ error, scope }));
  }
}

export function* deleteFieldPinSaga({ payload }) {
  const { pinId, scope, definition } = payload;
  try {
    yield put(
      updateTableColumnDefinition.trigger({
        scope,
        definition,
        data: { isPinUpdating: true },
      })
    );
    const URL = `${envConfig.APIG_URL}core/field-pins/${pinId}`;
    yield call(request, URL, {
      method: 'DELETE',
    });

    yield put(deleteFieldPin.success({ pinId, scope }));
    yield put(
      updateTableColumnDefinition.trigger({
        scope,
        definition,
        data: { isPinUpdating: false },
      })
    );
  } catch (error) {
    yield put(deleteFieldPin.failure({ pinId, scope, error }));
  }
}

export function* createFieldPinSaga({ payload }) {
  const {
    customColumnId,
    type,
    scope,
    definition,
    globalPresetType,
    valueArray,
  } = payload;
  try {
    if (!globalPresetType) {
      yield put(
        updateTableColumnDefinition.trigger({
          scope,
          definition,
          data: { isPinUpdating: true },
        })
      );
    }
    const body = {
      customColumnId,
      type,
    };
    let URL = `${envConfig.APIG_URL}core/field-pins`;

    if (globalPresetType) {
      URL += `?globalPresetType=${globalPresetType}&level=${scope}`;
    }

    const response = yield call(request, URL, {
      method: 'POST',
      payload: globalPresetType ? valueArray : body,
    });

    let responseData = {
      pin: { ...response.data, customColumnId, type },
      scope,
    };
    if (globalPresetType) {
      responseData = {
        pin: { ...response.data, type },
        scope,
        successMessage: SUCCESS_MESSAGES.GLOBAL_PRESET,
      };
    }
    yield put(createFieldPin.success(responseData));
    if (!globalPresetType) {
      yield put(
        updateTableColumnDefinition.trigger({
          scope,
          definition,
          data: { isPinUpdating: false },
        })
      );
    }
    if (globalPresetType) {
      yield put(fetchGlobalPreSetData.trigger());
    }
  } catch (error) {
    yield put(createFieldPin.failure({ customColumnId, scope, error }));
  }
}

export default function* root() {
  yield all([takeLatest(fetchFieldPins.TRIGGER, fetchFieldPinsSaga)]);
  yield all([takeEvery(deleteFieldPin.TRIGGER, deleteFieldPinSaga)]);
  yield all([takeEvery(createFieldPin.TRIGGER, createFieldPinSaga)]);
}
